module.exports = __webpack_public_path__ + "img/itx-pin-action-edit.65b2fa9a.svg";